<template>
  <div :class="momentFromNow(lastStatus).class">
    {{ momentFromNow(lastStatus).fromnow }}
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: "LastStatus",
  props: {
    lastStatus: {
      type: [String],
      default: () => '',
    },
  },
  methods: {
    momentFromNow(d) {
      const fromnow = moment(d).fromNow();

      const dates = [
        "a few seconds",
        "a minute",
        "minutes",
        "an hour",
        "hours",
      ];

      const filtered =
        dates.filter((d) => fromnow.includes(d)).map((d) => "status-ok")[0] ||
        "status-bad";
      return { fromnow, class: filtered };
    },
  },
};
</script>

<style scoped>
.status-bad {
  padding: 10px 2px 10px 2px;
  background-color: rgb(255, 111, 111);
}
</style>
